import { RefObject, useLayoutEffect, useState } from "react";

// The text is a dependency because new text can overflow without the element changing size, which the observer
// would miss. The child selector is for components such as DotLegalChip that do not hand out a ref to their text.
export function useIsOverflowing(ref: RefObject<HTMLElement | null>, text: string, childSelector?: string) {
    const [isOverflowing, setIsOverflowing] = useState(false);

    useLayoutEffect(() => {
        const element = childSelector ? ref.current?.querySelector<HTMLElement>(childSelector) : ref.current;
        if (!element) {
            return;
        }

        const updateOverflow = () => setIsOverflowing(element.scrollWidth > element.clientWidth);
        updateOverflow();

        const resizeObserver = new ResizeObserver(updateOverflow);
        resizeObserver.observe(element);
        return () => resizeObserver.disconnect();
    }, [ref, text, childSelector]);

    return isOverflowing;
}
